module.exports = __webpack_public_path__ + "static/media/Sunny soffa 3-sits xl tyg rober miljö 2023.a66b72b1.jpg";